import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  loadEventListPage,
  unloadEventListPage
} from "../../redux/actions/asset.actions";
import EventList from "../../components/EventList";
import Nav from "../../components/Nav";
import Header from "../../components/Header";
import { Translation } from "react-i18next";
import i18n from "../../languages/lang.js";

function Events() {
  const asset = useSelector(state => state.asset);
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(loadEventListPage(1, "all"));
    return () => dispatch(unloadEventListPage());
  }, []);

  if (!asset.events) {
    return (
      <Translation>
        {t => (
          <div id="main">
            <Nav selected={"events"} />
            <div id="content">
              <Header />
              <div id="loading">{t("system.loading")}</div>
            </div>
          </div>
        )}
      </Translation>
    );
  }
  return (
    <Translation>
      {t => (
        <div id="main">
          <Nav selected={"events"} />
          <div id="content">
            <Header />
            <div className="content-wrap">
              <div className="box-header">
                <Link className="header-button" to="/events/add">
                  {t("event.create_button")}
                </Link>
                <h2>{t("event.list_title")}</h2>
              </div>
              <EventList data={asset.events} />
            </div>
          </div>
        </div>
      )}
    </Translation>
  );
}

export default Events;
